import React, {useEffect, useRef, useState} from "react";
import {Box, Button, View} from "@unibuddy/patron";
import {sharedEvents} from "shared/AnalyticsNew/constants/productSpecification";
import useAnalytics from "shared/AnalyticsNew/hooks/useAnalytics";
import {IconXMark} from "@unibuddy/icons";

import {usePostMessage} from "./usePostMessage";
import useUniversityColor from "../UniversityProvider/hooks/useUniversityColor";
import {WidgetTrafficDriverIcon} from "./WidgetTrafficDriverIcon";
import {useUniversity} from "../UniversityProvider/UniversityProvider";
import {WidgetTrafficDriverPrompt} from "./WidgetTrafficDriverPrompt";

export const PROMPT_DELAY = 7000;
export const OPEN_WIDGET_LABEL = "Chat to students and staff";
export const CLOSE_WIDGET_LABEL = "Close Widget";

export function WidgetTrafficDriverCta() {
    const [open, setOpen] = React.useState(false);
    const {postMessage} = usePostMessage();
    const {trackEvent} = useAnalytics();
    const {slug: universitySlug} = useUniversity();
    const universityColor = useUniversityColor();
    const [promptActive, setPromptActive] = useState(false);
    const promptAutoShow = useRef(null);

    const handlePromptClose = () => {
        clearTimeout(promptAutoShow.current as NodeJS.Timeout);
        setPromptActive(false);
    };

    // Need to add a useEffect to set a timeout function to show prompt
    // If tge CTA is active however, we do not show prompt
    // This useEffect hook is used to show the prompt
    // automatically after 7 seconds.
    // In order to be able to cancel it (below) we
    // make use of a ref
    useEffect(() => {
        promptAutoShow.current = setTimeout(() => {
            setPromptActive(true);
        }, PROMPT_DELAY);
        return () => clearTimeout(promptAutoShow.current as NodeJS.Timeout);
    }, []);

    const handleClick = () => {
        trackEvent(sharedEvents.widgetTrafficDriverCtaButtonClicked.name, {
            universitySlug,
            action: !open ? "Open" : "Close",
            cta: "Widget Traffic Driver",
        });

        postMessage(`widgetTrafficDriverVisible=${!open as unknown as string}`);

        handlePromptClose();
        setOpen(!open);
    };

    return (
        <Box position={"absolute"} bottom={"24px"} right={"24px"}>
            <View alignItems={"flex-end"} height={"100%"} width={"100%"}>
                {!open && promptActive && (
                    <WidgetTrafficDriverPrompt
                        onPromptClick={handleClick}
                        onPromptClose={handlePromptClose}
                        promptActive={promptActive}
                    />
                )}
                <Button
                    onClick={handleClick}
                    style={{
                        width: "56px",
                        height: "56px",
                        backgroundColor: universityColor,
                        color: "white",
                    }}
                    round
                    iconOnly
                    aria-label={!open ? OPEN_WIDGET_LABEL : CLOSE_WIDGET_LABEL}
                >
                    {!open ? <WidgetTrafficDriverIcon /> : <IconXMark width="32px" height="32px" />}
                </Button>
            </View>
        </Box>
    );
}
